module.exports = __webpack_public_path__ + "img/code4.cc3204b3.png";